import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import Login from './pages/Login/Login';
import MainLayout from './layouts/MainLayout/MainLayout';
import AccidentFiling from './pages/AccidentFiling/AccidentFiling';
import AccidentQuery from './pages/AccidentQuery/AccidentQuery';
import Statistics from './pages/Statistics/Statistics';
import UserManagement from './pages/UserManagement/UserManagement';
import UserUnitManagement from './pages/UserUnitManagement/UserUnitManagement';
import DictionaryManagement from './pages/Dictionaries/DictionaryManagement';
import ChangePassword from './pages/ChangePassword/ChangePassword';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import './App.css';

dayjs.locale('zh-cn');

function App() {
    const router = createBrowserRouter(
        [
            { path: '/login', element: <Login /> },
            {
                path: '/',
                element: (
                    <PrivateRoute>
                        <MainLayout />
                    </PrivateRoute>
                ),
                children: [
                    { path: 'accident-filing', element: <AccidentFiling /> },
                    { path: 'accident-query', element: <AccidentQuery /> },
                    { path: 'statistics', element: <Statistics /> },
                    { path: 'user-management', element: <UserManagement /> },
                    { path: 'user-units', element: (
                        <AdminRoute>
                            <UserUnitManagement />
                        </AdminRoute>
                    ) },
                    { path: 'dictionaries', element: <DictionaryManagement /> },
                    { path: 'change-password', element: <ChangePassword /> },
                    { index: true, element: <Navigate to="/accident-filing" replace /> }
                ]
            },
            { path: '*', element: <Navigate to="/" replace /> }
        ],
        {
            // Opt-in future flags to silence deprecation warnings and test v7 behaviors
            future: {
                v7_startTransition: true,
                v7_relativeSplatPath: true
            }
        }
    );

    // Temporary debug hook removed: router future flags are not exposed by this build at runtime.
    // If you still need to inspect router internals, re-add a focused debug helper during local testing.

    return (
        <ConfigProvider
            locale={zhCN}
            theme={{
                token: {
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", "Source Han Sans SC", "Hiragino Sans GB", "Microsoft YaHei", "Noto Sans CJK SC", sans-serif',
                    colorPrimary: '#667eea'
                }
            }}
        >
            <RouterProvider router={router} />
        </ConfigProvider>
    );
}

export default App;
